import {getPaddingsBlock, getPaddingsInline} from "@/pipes/theme.pipe";
import {css} from "styled-components";


export const getButtonPaddings = (padding) => css`
    padding-inline: ${getButtonPaddingsInline(padding)};
    padding-block: ${getButtonPaddingsBlock(padding)};
`

export const getButtonPaddingsInline = (padding) => css`
    clamp(${getPaddingsInline('buttons', 'xs')}, 6vw, ${getPaddingsInline('buttons', padding)})
`

export const getButtonPaddingsBlock = (padding) => css`
    clamp(${getPaddingsBlock('buttons', 'xs')}, 2vw, ${getPaddingsBlock('buttons', padding)})
`
